import React, { FC, forwardRef } from 'react';
import { default as MuiButton } from '@material-ui/core/Button';
import { ButtonProps } from './types';

const Button: FC<ButtonProps> = forwardRef<HTMLButtonElement, ButtonProps>((
  {
    children,
    size = 'small',
    color = 'default',
    variant = 'contained',
    disabled = false,
    onClick,
    ...restProps
  },
  ref,
) => {
  return (
    <MuiButton
      onClick={onClick}
      color={color}
      disabled={disabled}
      size={size}
      variant={variant}
      ref={ref}
      {...restProps}
    >
      {children}
    </MuiButton>
  );
});

export default Button;
